import { createPayloadAction } from '../helpers';
import { StandardAction } from '../types';
import { ISelectedAppointmentContactState } from './types';

export default class SelectedAppointmentContactAction {
  static TYPES = {
    SET_SELECTED_APPOINTMENT_CONTACT: 'selectedAppointmentContact/SET_SELECTED_APPOINTMENT_CONTACT',
    DESELECT_APPOINTMENT_CONTACT: 'selectedAppointmentContact/DESELECT_APPOINTMENT_CONTACT',
  };

  static setSelectedAppointmentContact = (
    contact: Partial<ISelectedAppointmentContactState>,
  ): StandardAction<Partial<ISelectedAppointmentContactState>> =>
    createPayloadAction(SelectedAppointmentContactAction.TYPES.SET_SELECTED_APPOINTMENT_CONTACT, contact);

  static deselectAppointmentContact = (): StandardAction =>
    createPayloadAction(SelectedAppointmentContactAction.TYPES.DESELECT_APPOINTMENT_CONTACT);
}
